import React, { Component } from 'react';

import './index.css';
import Info from './components/info';
import Navigation from './components/navigation';
import Legend from './components/legend';
import Download from './components/download-map';
import UIZoom from './components/uiZoom';
import { updDim, selectElement, cableCanBeSelected } from './helpers/helpers';
import Map from './components/map/map';
import WT from './components/walkthrought';

import dataCables from './data/cables_cables';
import ddata from './data/points_data';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pos: [-50, 30],
			dPos: [-50, 12],
			zoomInit: 10000,
			level: 1,
			dLevel: 1,
			move: false,
			menu: false,
			legend: false,
			step: 0,
			size: {
				device: 'mobile',
				width: 0,
				height: 0
			},
			selected: {
				layer: 'network',
				now: false,
				type: '',
				data: {},
				name: ''
			},
			sel: {
				now: false,
				name: '',
				x: 0,
				y: 0
			}
		};
		this.urlTo = this.urlTo.bind(this);
		this.moveTo = this.moveTo.bind(this);
		this.closeInfo = this.closeInfo.bind(this);
		this.initAnimatedMove = this.initAnimatedMove.bind(this);
		this.animatedMove = this.animatedMove.bind(this);
		this.stop = this.stop.bind(this);
		this.zoomSet = this.zoomSet.bind(this);
		this.nextStep = this.nextStep.bind(this);
	}

	componentWillMount() {
		this.setState(updDim());
	}

	componentDidMount() {
		const match = this.props.match;
		const p = this.props.match.params;
		window.addEventListener('resize', () => this.setState(updDim()));
		match.path === '/'
			? this.closeInfo()
			: match.path === '/:layer/:type/:id'
			? p.id.toLowerCase() !== this.state.selected.name.toLowerCase() &&
			  this.moveTo(p.layer.toLowerCase(), p.type.toLowerCase(), p.id.toLowerCase())
			: match.path === '/:layer' && this.moveTo(match.params.layer.toLowerCase(), '', '');
		document.getElementById('loading').remove();
	}

	componentDidUpdate(prev, prevState) {
		const path = this.props.match.path;
		const p = this.props.match.params;
		path !== '/' && path === '/:layer/:type/:id'
			? prev.match.params.id !== p.id &&
			  (p.id.toLowerCase() !== this.state.selected.name.toLowerCase() &&
					this.moveTo(p.layer.toLowerCase(), p.type.toLowerCase(), p.id.toLowerCase()))
			: path === '/:layer' && prev.match.params.layer !== p.layer && this.moveTo(p.layer.toLowerCase(), '', '');

		if (this.state.move && !prevState.move) {
			this.initAnimatedMove();
		}
		if (this.state.move) {
			if (
				this.state.dPos[0] === this.state.pos[0] &&
				this.state.dPos[1] === this.state.pos[1] &&
				this.state.dLevel === this.state.level
			) {
				this.stop();
			}
		}
	}

	urlTo(layer, type, name) {
		if (cableCanBeSelected(name)) {
			const urlName = name
				.toLowerCase()
				.split(' ')
				.join('_');
	
			if (type === 'cable') {
				this.setState({
					...this.state,
					sel: { ...this.state.sel, now: false }
				});
			}
			const actLayer = layer === '' ? this.state.selected.layer : layer;
			type !== 'close'
				? this.props.history.push(type !== '' ? '/' + actLayer + '/' + type + '/' + urlName : '/' + actLayer)
				: this.props.history.push('/');
		}
	}

	initAnimatedMove = () => {
		if (this.state.size.device === 'mobile') {
			this.setState(
				{
					pos: this.state.dPos,
					level: this.state.dLevel
				},
				this.stop()
			);
		} else {
			this.setState(
				{
					move: true
				},
				this.animatedMove()
			);
		}
	};

	animatedMove = () => {
		if (
			this.state.dPos[0] !== this.state.pos[0] ||
			this.state.dPos[1] !== this.state.pos[1] ||
			this.state.dLevel !== this.state.level
		) {
			const mova = this.state.dPos[0] - this.state.pos[0];
			const movb = this.state.dPos[1] - this.state.pos[1];
			const movc = this.state.dLevel - this.state.level;

			if (Math.abs(mova) > 0.1 || Math.abs(movb) > 0.1 || Math.abs(movc) > 0.1) {
				const a = this.state.pos[0] + (this.state.dPos[0] - this.state.pos[0]) / 3;
				const b = this.state.pos[1] + (this.state.dPos[1] - this.state.pos[1]) / 3;
				const c = this.state.level + (this.state.dLevel - this.state.level) / 3;
				this.setState(
					{
						pos: [a, b],
						level: c
					},
					() => {
						setTimeout(this.animatedMove, 1);
					}
				);
			} else {
				this.setState(
					{
						pos: this.state.dPos,
						level: this.state.dLevel
					},
					this.stop()
				);
			}
		} else {
			this.setState(
				{
					pos: this.state.dPos,
					level: this.state.dLevel
				},
				this.stop()
			);
		}
	};
	stop() {
		this.setState({ move: false });
	}

	moveTo(layer, type, name) {
		if (cableCanBeSelected(name)) {
			const d =
				type === 'location'
					? selectElement(ddata, name.split('_').join(' '))
					: type === 'cable'
					? selectElement(dataCables, name.split('_').join(' '))
					: {
							name: '',
							lon: -50,
							lat: 12,
							zoom: 1,
							now: false
						};
			const data = {
				...this.state,
				selected: {
					...this.state.selected,
					layer: layer === '' ? this.state.selected.layer : layer,
					now: type === 'location' || type === 'cable',
					type: type === 'location' ? 'pop' : type,
					data: d,
					name: d.name
				},
				dPos: [d.lon, d.lat],
				dLevel: d.zoom,
				move: true
			};
			this.setState(data);
		}
	}

	// Función cuando el usuario selecciona una Capa
	selectLayer = (name) => {
		this.setState({
			selected: {
				...this.state.selected,
				layer: name,
				now: false,
				data: '',
				type: 'none',
				name: ''
			},
			dPos: [-50, 12],
			dLevel: 1
		});
	};

	// Función cuando el usuario selecciona un cable
	cableHover = (now, name, x, y) => {
		if (cableCanBeSelected(name)) {
			this.setState({
				sel: {
					now: now,
					name: name,
					x: this.state.size.device === 'mobile' ? 20 + x : x,
					y: y - 36
				}
			});
		}
	};

	// Setea el zoom
	zoomSet(newLevel) {
		this.setState({
			dLevel: newLevel,
			move: true
		});
	}

	newSetPos(pos) {
		this.setState({
			dPos: [pos[0], pos[1]],
			move: true
		});
	}

	// Cierra el menu de información sobre cables y pops y vuelve al inicio
	closeInfo = () => {
		this.setState({
			selected: {
				...this.state.selected,
				now: false,
				data: '',
				type: 'none',
				name: ''
			},
			dPos: [-50, 12],
			dLevel: 1,
			move: true
		});
	};

	nextStep = (paso) => {
		this.setState({
			...this.state,
			step: paso
		});
	};

	render() {
		const mobile = this.state.size.device === 'mobile' ? true : false;
		const width = mobile
			? this.state.size.width
			: this.state.selected.now
			? this.state.size.width - 220
			: this.state.size.width;
		const height = !mobile
			? this.state.size.height
			: this.state.selected.now
			? this.state.size.height - 190
			: this.state.size.height;
		return (
			<div
				className={
					'App ' +
					this.state.size.device +
					(this.state.selected.layer !== 'network_map' ? ' layer layer-' + this.state.selected.layer + ' ' : ' base ')
				}
			>
				<Map
					mobile={mobile}
					f={{
						urlTo: this.urlTo,
						cableHover: this.cableHover.bind(this),
						move: this.newSetPos.bind(this),
						zoomSet: this.zoomSet
					}}
					s={{
						move: this.state.move,
						pos: this.state.pos,
						dPos: this.state.dPos,
						size: {
							device: this.state.size.device,
							width: width,
							height: height
						},
						zoomInit: this.state.zoomInit,
						level: this.state.level,
						selected: {
							layer: this.state.selected.layer,
							now: this.state.selected.now,
							type: this.state.selected.type,
							data: this.state.selected.data,
							name: this.state.selected.name
						}
					}}
				/>

				<Navigation
					mobile={mobile}
					open={() => {
						this.setState({
							menu: true
						});
					}}
					close={() => {
						this.setState({
							menu: false
						});
					}}
					state={this.state}
					urlTo={this.urlTo}
				/>

				{this.state.selected.now && (
					<Info
						selected={this.state.selected}
						h={this.state.size.height}
						w={this.state.size.width}
						reset={this.closeInfo}
						mobile={mobile}
						urlTo={this.urlTo}
					/>
				)}
				{!this.state.selected.now && (
					<Legend
						layer={this.state.selected.layer}
						mobile={mobile}
						show={this.state.legend}
						toggle={() => {
							this.setState((prev) => ({
								legend: !prev.legend
							}));
						}}
					/>
				)}
				{!this.state.selected.now && !mobile && (
					<UIZoom s={this.state} zoomSet={this.zoomSet} reset={this.closeInfo} mobile={mobile} />
				)}
				{!this.state.selected.now && this.state.selected.layer === 'network' && <Download mobile={mobile} />}
				{this.state.size.device !== 'mobile' && this.state.sel.now && (
					<div
						className={'cable-name'}
						style={{ top: this.state.sel.y + 'px', left: this.state.sel.x + 'px', pointerEvents: 'none' }}
					>
						{this.state.sel.name}
					</div>
				)}
				{mobile && this.state.step < 1 ? <WT next={this.nextStep} /> : undefined}
			</div>
		);
	}
}

export default App;
